import { createTheme as e } from "flowbite-react";
const r = [
  "[&::-webkit-slider-thumb]:appearance-none",
  "[&::-webkit-slider-thumb]:h-5",
  "[&::-webkit-slider-thumb]:w-5",
  "[&::-webkit-slider-thumb]:rounded-full",
  "[&::-webkit-slider-thumb]:bg-white",
  "[&::-webkit-slider-thumb]:border-2",
  "[&::-webkit-slider-thumb]:border-[#1C64F2]",
  "[&::-webkit-slider-thumb]:shadow-md",
  "[&::-webkit-slider-thumb]:cursor-pointer",
  "[&::-webkit-slider-thumb]:transition-transform",
  "[&::-webkit-slider-thumb]:hover:scale-110",
  "[&::-moz-range-thumb]:appearance-none",
  "[&::-moz-range-thumb]:h-5",
  "[&::-moz-range-thumb]:w-5",
  "[&::-moz-range-thumb]:rounded-full",
  "[&::-moz-range-thumb]:bg-white",
  "[&::-moz-range-thumb]:border-2",
  "[&::-moz-range-thumb]:border-[#1C64F2]",
  "[&::-moz-range-thumb]:shadow-md",
  "[&::-moz-range-thumb]:cursor-pointer",
  "[&::-moz-range-thumb]:transition-transform",
  "[&::-moz-range-thumb]:hover:scale-110"
].join(" "), o = e({
  rangeSlider: {
    root: {
      base: "flex"
    },
    field: {
      base: "relative w-full",
      input: {
        base: `w-full cursor-pointer appearance-none rounded-full bg-white/15 dark:bg-white/15 border border-white/20 dark:border-white/20 backdrop-blur-[15px] focus:outline-none focus:ring-2 focus:ring-[#1C64F2]/40 disabled:cursor-not-allowed disabled:opacity-50 ${r}`,
        sizes: {
          sm: "h-1.5",
          md: "h-2.5",
          lg: "h-3.5"
        }
      }
    }
  }
}).rangeSlider;
export {
  o as rangeSliderTheme
};
